import dayjs, { Dayjs } from 'dayjs';
import { PensionPlanTransfer } from '../api/pension-plan-transfers/interfaces/PensionPlanTransfer';
import { validYearsToRetirement } from './monthlyProjection';

/** Edad de jubilación con la que comparsa calcula los tramos (edad = 67 − años). */
const RETIREMENT_AGE = 67;

/**
 * Edad aproximada de quien no tiene fecha de nacimiento, con los años hasta la jubilación que
 * dijo en el funnel (`metadata.years_to_retirement` del traspaso más reciente que los tenga):
 * 67 − esos años, más los que han pasado desde entonces. Mejor que el 50/50 de no saber nada
 * (Arca-Team/product#32). `undefined` si no hay o si sale fuera de 18 a 66 (comparsa no la admite).
 *
 * Ojo: la comparación del traspaso (`ExplorationView`, la Comparativa de `IndividualDashboardV2`)
 * usa los años del funnel tal cual, como foto de lo que vio al hacerlo; el resto de pantallas, esta
 * edad, que ya suma el tiempo pasado. Si hace más de un año, pueden diferir en un tramo.
 * `createdAt` es el del traspaso: en uno rehecho a mano por operaciones, la edad sale algo más baja.
 */
export function ageFromFunnel(
	transfers: ReadonlyArray<PensionPlanTransfer>,
	today: Dayjs = dayjs()
): number | undefined {
	const masReciente = transfers
		.map((t) => ({ t, years: validYearsToRetirement(t.metadata?.years_to_retirement) }))
		.filter(({ years }) => years !== undefined)
		.sort((a, b) => dayjs(b.t.createdAt).valueOf() - dayjs(a.t.createdAt).valueOf())[0];
	if (!masReciente) return undefined;
	const age =
		RETIREMENT_AGE -
		(masReciente.years as number) +
		today.diff(dayjs(masReciente.t.createdAt), 'year');
	return age >= 18 && age < RETIREMENT_AGE ? age : undefined;
}
